import type { Notification } from '@/shared/types/notifications';
import { MovieAnnouncementsNotification } from '@/scenarios/profiles/lib/MovieAnnouncementTypes';

export const transformMovieAnnouncementsNotification = (
    notification: Notification
): MovieAnnouncementsNotification | null => {
    const { payload, notificationPayloadId, feedbackToken } = (notification ||
        {}) as MovieAnnouncementsNotification;

    const validItems =
        payload?.items
            ?.filter((item) => item?.contentId && item?.coverUrl && item?.logoUrl)
            .map((item) => ({
                ...item,
                coverUrl: /\/orig$/.test(item.coverUrl) ? item.coverUrl : `${item.coverUrl}/orig`,
                logoUrl: /\/orig$/.test(item.logoUrl) ? item.logoUrl : `${item.logoUrl}/orig`,
            })) || [];

    const isValidNotification = (feedbackToken || notificationPayloadId) && validItems.length;

    return isValidNotification
        ? {
              feedbackToken: feedbackToken || notificationPayloadId,
              notificationPayloadId,
              payload: { items: validItems },
          }
        : null;
};
